/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import React, { Component } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import Loader from '../loader';
import { UtrModalBody } from './UtrModalBody';
import {
  closeUniversalTrackerModal,
  reloadHistory,
} from '../../actions/universalTrackerModal';
import './styles.scss';
import { BasicAlert } from '../alert/BasicAlert';
import { RootState } from '../../reducers';
import { FeaturePermissions } from '../../services/permissions/FeaturePermissions';
import UniversalTrackerModalService from '../../model/UniversalTrackerModalService';
import { canManageCurrentLevel, getCurrentUser } from '../../selectors/user';
import { UtrvHistoryModalTemplate } from './UtrvHistoryModalTemplate';

class UTrModal extends Component<PropsFromRedux> {

  closeModal = () => {
    this.props.closeUniversalTrackerModal();
  };

  render() {
    const { universalTrackerModalState, canAccessCustomDashboards, reloadHistory, currentUser, canManage } = this.props;
    const { open, loadedOverview, errored, errorMessage, modalService } = universalTrackerModalState;
    if (!open) {
      return '';
    }

    // If there is an error, Container will handle that.
    if (!errored && !loadedOverview) {
      return <Loader />;
    }

    if (errored || !modalService) {
      return this.renderModal(
        <BasicAlert type={'danger'}>{errorMessage}</BasicAlert>
      );
    }

    return this.renderModal(
      <UtrModalBody
        modalService={modalService}
        alternativeCode={universalTrackerModalState.alternativeCode}
        canAccessCustomDashboards={canAccessCustomDashboards}
        hideProvenance={universalTrackerModalState.hideProvenance}
        reloadUtrvs={() => reloadHistory(modalService)}
        currentUser={currentUser}
        activeTabId={universalTrackerModalState.activeTabId}
        showTargetBaselineAdding={canManage}
      />
    );
  }

  renderModal(body: JSX.Element) {
    return <UtrvHistoryModalTemplate toggle={this.closeModal}>{body}</UtrvHistoryModalTemplate>;
  }
}

const mapStateToProps = (state: RootState) => ({
  universalTrackerModalState: state.universalTrackerModal,
  canAccessCustomDashboards: FeaturePermissions.canAccessCustomDashboards(state),
  currentUser: getCurrentUser(state),
  canManage: canManageCurrentLevel(state),
});

const mapDispatchToProps = (dispatch: Function) => {
  return {
    closeUniversalTrackerModal: () => { dispatch(closeUniversalTrackerModal()) },
    reloadHistory: (modalService: UniversalTrackerModalService) => { dispatch(reloadHistory(modalService)) },
  }
}

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>

export default connector(UTrModal);
